/* Kioraa revamp — shared dependency-free carousel.
   Markup contract (slides are direct children of the track):
     <div class="kinn-carousel" data-kinn-carousel>
       <div class="kinn-carousel__track">...slides...</div>
       <button class="kinn-carousel__btn" data-dir="-1">...</button>
       <button class="kinn-carousel__btn" data-dir="1">...</button>
     </div>
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(root) {
    if (root.dataset.kinnCarouselReady === 'true') return;
    root.dataset.kinnCarouselReady = 'true';

    var track = root.querySelector('.kinn-carousel__track');
    var buttons = Array.prototype.slice.call(
      root.querySelectorAll('.kinn-carousel__btn[data-dir]')
    );
    if (!track) return;

    function slideStep() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return (first.getBoundingClientRect().width + gap) || track.clientWidth;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll - 1;
      buttons.forEach(function (btn) {
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        btn.disabled = maxScroll <= 1 || (dir < 0 ? atStart : atEnd);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        track.scrollBy({
          left: dir * slideStep(),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateButtons();
      });
    }, { passive: true });

    window.addEventListener('resize', updateButtons);
    updateButtons();

    /* Auto-scroll. Opt in per section with data-kinn-autoplay="<ms>". It advances one slide at
       a time and wraps back to the start at the end, pauses while the pointer is over the
       carousel or focus is inside it (so it never yanks a link away mid-click), pauses when the
       tab is hidden, and stays off entirely for reduced-motion users. */
    var delay = parseInt(root.getAttribute('data-kinn-autoplay'), 10);
    if (delay > 0 && !reduceMotion.matches) {
      var timer = null;
      var paused = false;

      var advance = function () {
        if (paused || document.hidden) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 1) return;
        if (track.scrollLeft >= maxScroll - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: slideStep(), behavior: 'smooth' });
        }
      };

      var start = function () { if (!timer) timer = setInterval(advance, delay); };
      var stop = function () { clearInterval(timer); timer = null; };

      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) paused = false;
      });
      /* A manual drag or arrow click should hand control back to the reader for a beat. */
      track.addEventListener('pointerdown', function () {
        paused = true;
        setTimeout(function () { paused = false; }, delay * 2);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      /* Safari <14 only has the deprecated addListener; without this guard the throw would
         happen before start() and autoplay would never begin on those browsers. */
      if (typeof reduceMotion.addEventListener === 'function') {
        reduceMotion.addEventListener('change', function (e) { if (e.matches) stop(); else start(); });
      } else if (typeof reduceMotion.addListener === 'function') {
        reduceMotion.addListener(function (e) { if (e.matches) stop(); else start(); });
      }

      /* Start unconditionally. advance() already no-ops while the tab is hidden, so a page
         opened in a background tab still has a live timer that resumes the moment it is shown,
         rather than depending on a visibilitychange that may never fire. */
      start();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-kinn-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when the theme editor injects or re-renders a section. */
  document.addEventListener('shopify:section:load', initAll);
})();
